import store from "@frameworks/web/redux/store";
import { LOCATEUS, LOCATEUS_ERROR, LOCATEUS_HIDE_ERROR, LOCATEUS_START_LOADER, LOCATEUS_STOP_LOADER } from "@frameworks/web/redux/interfaces/StaticFooter/iLocateUs";
class LocateUsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getlocationData(data) {
        this.dispatch({
            type: LOCATEUS,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: LOCATEUS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: LOCATEUS_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: LOCATEUS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: LOCATEUS_STOP_LOADER,
        });
    }
}
export default LocateUsActions;
